
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $27c544099a3bc072$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["5ZPII","index.5414ccc8.js","ctObJ","WevrLogoTextBeta.8ba9d2c8.svg","4k0Bl","WevrLogoPrimary.a2f6d063.svg","kzdEm","query.99507992.png","20u8V","base.a5d2b23d.svg","02dF4","bitcoin-1.d48db2ac.svg","lInFe","linea.cd3a1e8c.svg","a7r06","ethereum1.6a72ab43.svg","lPdSb","gnosis.61d3829e.svg","4Z7jC","optimism.0579c3e6.svg","9PDqD","clickhouse.53526bb6.svg","4pVpj","CL-May-Week2.c9fa966e.png","5Efqv","chart-section.0f29c508.png","brzzc","pairs_created.0fd9430a.png","fCD5z","nft-wevr.683bb794.png","8Yija","WevrLogoSecondary.c31fdafd.svg","hN7kv","WevrWatermark.631d8fcc.svg","KlkTU","26-01-24-AvgGas.578bd958.png","jPQYJ","WevrMasterAgreement.41ae5d4f.pdf","8MIOz","WevrTerms&Conditions.32cb3cf7.pdf","k0GE8","PrivacyPolicy.47daa0e3.pdf","3Nvzn","networkGraph.cf16ec9b.js","10d2H","eth.77f0cd7e.svg"]'));


//# sourceMappingURL=index.runtime.24e0885f.js.map
